import React from 'react';
import logService from '../services/LogService'
import { PatientDetails } from '../components/PatientDetails'
import { VaccinationTable } from '../components/VaccinationTable'
import { ForecasterTable } from '../components/ForecasterTable'
import { ImmunityTable } from '../components/ImmunityTable'
import { InstanceCombobox } from '../components/InstanceCombobox'
import { CertTypeCombobox } from '../components/CertTypeCombobox';
import { DetailHistoryCombobox } from '../components/DetailHistoryCombobox';
import { useSelector, useDispatch } from "react-redux";
import { setCertificateType, setServerInstance, clearDetails } from "../actions/searchAction";

export const Details = (props) => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  const handleDownloadCertificate = (dataSource, serverInstance, authorityId, requestId, certTypeValue) => {
    console.log('Requesting certificate');
    logService.getCertificate(dataSource, serverInstance, authorityId, requestId, certTypeValue);
  }

  const handleDownloadRequest = (dataSource, authorityId, requestId) => {
    console.log('Requesting raw request');
    logService.getRequestFile(dataSource, authorityId, requestId);
  }

  let contents = (state.selectedDetails === undefined)
    ? <p><em>Loading...</em></p>
    : (
      <div>
        <PatientDetails patient={state.selectedDetails.request.patient} />
        <VaccinationTable 
            vaccinationList={state.selectedDetails.request.vaccinationList} 
            patientDob={state.selectedDetails.request.patient.dob}
        />
        <ForecasterTable forecastEvaluationList={state.selectedDetails.request.forecastEvaluationList} />
        <ImmunityTable immunityEventList={state.selectedDetails.request.immunityEventList} />
      </div>
    );

  let idcontent = (state.selectedDetails === undefined) ? <p></p> : (
    <>
      <div className="row">
        <div className="col-md-5 align-self-start font-weight-light">
          Tracking ID: {state.selectedDetails.id}
        </div>
        <div className="col-md-5 align-self-start font-weight-light">
          ImmsLink ID: {state.selectedDetails.request.immslinkMessageKey}
        </div>
        <div className="col align-self-end">
          <InstanceCombobox
            selectedInstance={state.serverInstance}
            onChangeState={(e) => dispatch(setServerInstance(e))} />
        </div>
      </div>
      <div className="row">
        <div className="d-flex justify-content-start">
          <DetailHistoryCombobox
            className='btn btn-primary'
            />
          <button
            className="ms-2 btn btn-info"
            onClick={(e) => dispatch(clearDetails())} >Clear List</button>
        </div>
        <div className="d-flex justify-content-end">
          <button
            className="me-2 btn btn-info"
            onClick={(e) => {
              handleDownloadRequest(
                state.dataSource,
                state.searchModel.authorityName,
                state.selectedDetails.id,
              );
            }} 
          >Download Raw Request</button>
          <CertTypeCombobox
            className='btn btn-primary'
            selectedCertLabel={state.certificateLabel}
            onChange={(e) => dispatch(setCertificateType(e)) } />
          <button
            className="ms-2 btn btn-primary"
            onClick={(e) => {
              handleDownloadCertificate(
                state.dataSource,
                state.serverInstance,
                state.searchModel.authorityName,
                state.selectedDetails.id,
                state.certificateLabel
              );
            }}
            >View Certificate</button>
        </div>
      </div>
    </>
  );

  return (<div>
    <h1 id="tabelLabel" >Immucert Request</h1>
    {idcontent}
    {contents}
  </div>);
}
